import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/api";
import BuscadorCatalogo, { coincideBusqueda } from "./BuscadorCatalogo";
import Cargando from "./Cargando";
import CampoForm from "./CampoForm";

const formaVacia = {
  nombre_empresa: "",
  contacto: "",
  telefono: "",
  correo: "",
  direccion: "",
  ruc: "",
  rubro: "",
  categoria_id: "",
  retencion_ids: [],
  tiene_credito: false,
  formas_pago: [],
  exento_iva: false,
};

function GestionarProveedores() {
  const [proveedores, setProveedores] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [retenciones, setRetenciones] = useState([]);
  const [form, setForm] = useState(formaVacia);
  const [editandoId, setEditandoId] = useState(null);
  const [formAbierto, setFormAbierto] = useState(false);
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");

  const cargar = () => {
    setCargando(true);
    Promise.all([apiFetch("/api/proveedores"), apiFetch("/api/categorias-proveedor"), apiFetch("/api/retenciones")])
      .then(([proveedoresData, categoriasData, retencionesData]) => {
        setProveedores(proveedoresData || []);
        setCategorias(categoriasData || []);
        setRetenciones((retencionesData || []).filter((r) => r.activa));
      })
      .catch((err) => setError(err.message))
      .finally(() => setCargando(false));
  };

  useEffect(cargar, []);

  const actualizarCampo = (campo, valor) => setForm((prev) => ({ ...prev, [campo]: valor }));

  const alternarFormaPago = (forma) => {
    setForm((prev) => ({
      ...prev,
      formas_pago: prev.formas_pago.includes(forma)
        ? prev.formas_pago.filter((f) => f !== forma)
        : [...prev.formas_pago, forma],
    }));
  };

  const alternarRetencion = (id) => {
    setForm((prev) => ({
      ...prev,
      retencion_ids: prev.retencion_ids.includes(id) ? prev.retencion_ids.filter((r) => r !== id) : [...prev.retencion_ids, id],
    }));
  };

  const guardar = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.nombre_empresa.trim()) {
      setError("El nombre de la empresa es obligatorio.");
      return;
    }
    try {
      const url = editandoId ? `/api/proveedores/${editandoId}` : "/api/proveedores";
      await apiFetch(url, { method: "POST", body: JSON.stringify(form) });
      setForm(formaVacia);
      setEditandoId(null);
      setFormAbierto(false);
      cargar();
    } catch (err) {
      setError(err.message);
    }
  };

  const editar = (p) => {
    setEditandoId(p.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setForm({
      nombre_empresa: p.nombre_empresa || "",
      contacto: p.contacto || "",
      telefono: p.telefono || "",
      correo: p.correo || "",
      direccion: p.direccion || "",
      ruc: p.ruc || "",
      rubro: p.rubro || "",
      categoria_id: p.categoria_id || "",
      retencion_ids: p.retencion_ids || [],
      tiene_credito: !!p.tiene_credito,
      formas_pago: p.formas_pago ? p.formas_pago.split(",") : [],
      exento_iva: !!p.exento_iva,
    });
  };

  const cancelarEdicion = () => {
    setEditandoId(null);
    setFormAbierto(false);
    setForm(formaVacia);
  };

  const eliminar = async (id) => {
    if (!window.confirm("¿Eliminar este proveedor?")) return;
    try {
      await apiFetch(`/api/proveedores/${id}/eliminar`, { method: "POST", body: JSON.stringify({}) });
      cargar();
    } catch (err) {
      setError(err.message);
    }
  };

  const proveedoresVisibles = proveedores.filter((p) =>
    coincideBusqueda(busqueda, [
      p.nombre_empresa,
      p.ruc,
      p.categoria_nombre,
      p.rubro,
      p.contacto,
      p.telefono,
      p.correo,
      p.direccion,
    ])
  );

  return (
    <div style={styles.card}>
      <div style={{ ...styles.cardHeader, justifyContent: "space-between", flexWrap: "wrap" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
          <span style={styles.cardIcono}>🚚</span>
          <div>
            <h3 style={{ margin: 0, fontSize: "1rem", color: "var(--tema-titulo, #0b3c60)" }}>Proveedores</h3>
            <p style={{ margin: "0.1rem 0 0", fontSize: "0.78rem", color: "#8993a1" }}>
              {proveedores.length} registrado{proveedores.length === 1 ? "" : "s"}
            </p>
          </div>
        </div>
        {!formAbierto && !editandoId && (
          <button type="button" onClick={() => setFormAbierto(true)} style={styles.botonAgregar}>
            + Agregar proveedor
          </button>
        )}
      </div>

      {(formAbierto || editandoId) && (
      <form onSubmit={guardar} style={styles.form}>
        <section className="form-seccion">
          <div className="form-seccion-titulo">🏢 Datos de la empresa</div>
          <div className="form-grid" style={styles.grid}>
            <CampoForm etiqueta="Nombre de la empresa" obligatorio>
              <input value={form.nombre_empresa} onChange={(e) => actualizarCampo("nombre_empresa", e.target.value)} style={styles.input} />
            </CampoForm>
            <CampoForm etiqueta="RUC">
              <input value={form.ruc} onChange={(e) => actualizarCampo("ruc", e.target.value)} style={styles.input} />
            </CampoForm>
            <CampoForm etiqueta="Rubro">
              <input value={form.rubro} onChange={(e) => actualizarCampo("rubro", e.target.value)} style={styles.input} />
            </CampoForm>
            <CampoForm etiqueta="Categoría (para filtrar por área)">
              <select
                value={form.categoria_id}
                onChange={(e) => actualizarCampo("categoria_id", e.target.value)}
                style={styles.input}
              >
                <option value="">Sin categoría</option>
                {categorias.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.nombre}
                  </option>
                ))}
              </select>
            </CampoForm>
          </div>
        </section>

        <section className="form-seccion">
          <div className="form-seccion-titulo">📞 Contacto</div>
          <div className="form-grid" style={styles.grid}>
            <CampoForm etiqueta="Persona de contacto">
              <input value={form.contacto} onChange={(e) => actualizarCampo("contacto", e.target.value)} style={styles.input} />
            </CampoForm>
            <CampoForm etiqueta="Teléfono">
              <input value={form.telefono} onChange={(e) => actualizarCampo("telefono", e.target.value)} style={styles.input} />
            </CampoForm>
            <CampoForm etiqueta="Correo">
              <input value={form.correo} onChange={(e) => actualizarCampo("correo", e.target.value)} style={styles.input} />
            </CampoForm>
            <CampoForm etiqueta="Dirección">
              <input value={form.direccion} onChange={(e) => actualizarCampo("direccion", e.target.value)} style={styles.input} />
            </CampoForm>
          </div>
        </section>

        <section className="form-seccion">
          <div className="form-seccion-titulo">💰 Condiciones de compra</div>
          <div className="campo-form">
            <span>Crédito e IVA</span>
            <div className="opciones">
              <label className="opcion-chip">
                <input
                  type="checkbox"
                  checked={form.tiene_credito}
                  onChange={(e) => actualizarCampo("tiene_credito", e.target.checked)}
                />
                Tenemos crédito con este proveedor
              </label>
              <label className="opcion-chip">
                <input
                  type="checkbox"
                  checked={form.exento_iva}
                  onChange={(e) => actualizarCampo("exento_iva", e.target.checked)}
                />
                Exonerado de IVA (sin el 15%)
              </label>
            </div>
          </div>
          <div className="campo-form" style={{ marginTop: "0.7rem" }}>
            <span>Retenciones que se le aplican</span>
            {retenciones.length === 0 ? (
              <span style={{ fontWeight: 400, color: "#8993a1" }}>
                No hay retenciones creadas. El administrador las agrega en Parámetros.
              </span>
            ) : (
              <div className="opciones">
                {retenciones.map((r) => (
                  <label key={r.id} className="opcion-chip">
                    <input type="checkbox" checked={form.retencion_ids.includes(r.id)} onChange={() => alternarRetencion(r.id)} />
                    {r.nombre} {r.porcentaje}%
                  </label>
                ))}
              </div>
            )}
          </div>
          <div className="campo-form" style={{ marginTop: "0.7rem" }}>
            <span>Formas de pago aceptadas</span>
            <div className="opciones">
              {["transferencia", "cheque", "efectivo", "tarjeta"].map((forma) => (
                <label key={forma} className="opcion-chip">
                  <input
                    type="checkbox"
                    checked={form.formas_pago.includes(forma)}
                    onChange={() => alternarFormaPago(forma)}
                  />
                  {forma.charAt(0).toUpperCase() + forma.slice(1)}
                </label>
              ))}
            </div>
          </div>
        </section>

        <button type="submit" style={styles.botonAgregar}>
          {editandoId ? "Guardar cambios" : "Guardar proveedor"}
        </button>{" "}
        <button type="button" onClick={cancelarEdicion} style={styles.botonCancelar}>
          Cancelar
        </button>
      </form>
      )}

      {error && <p style={{ color: "#a3402f" }}>{error}</p>}

      {cargando ? (
        <Cargando compacto />
      ) : proveedores.length === 0 ? (
        <p className="vacio-simple">Todavía no hay proveedores registrados.</p>
      ) : (
        <>
        <BuscadorCatalogo
          valor={busqueda}
          onCambiar={setBusqueda}
          placeholder="Buscar por empresa, RUC, categoría, rubro, contacto, teléfono o correo…"
          mostrados={proveedoresVisibles.length}
          total={proveedores.length}
        />
        <div className="table-scroll" style={styles.tablaWrap}>
        <table style={styles.tabla}>
          <thead>
            <tr style={{ textAlign: "center", borderBottom: "1px solid #d3d9df" }}>
              <th style={styles.th}>Empresa</th>
              <th style={styles.th}>Categoría</th>
              <th style={styles.th}>Contacto</th>
              <th style={styles.th}>Retención</th>
              <th style={styles.th}>Crédito</th>
              <th style={styles.th}>IVA</th>
              <th style={styles.th}></th>
            </tr>
          </thead>
          <tbody>
            {proveedoresVisibles.map((p, i) => (
              <tr
                key={p.id}
                style={{
                  borderBottom: "1px solid #eef1f3",
                  background: editandoId === p.id ? "#f2e3d1" : i % 2 === 1 ? "#fafbfc" : "transparent",
                }}
              >
                <td style={{ ...styles.td, fontWeight: 600, color: "var(--tema-titulo, #0b3c60)" }}>{p.nombre_empresa}</td>
                <td style={styles.td}>
                  {p.categoria_nombre ? (
                    <span style={{ ...styles.badge, color: "var(--tema-primario, #2f6690)", background: "var(--tema-suave, #dceaf5)" }}>
                      {p.categoria_nombre}
                    </span>
                  ) : (
                    <span style={{ ...styles.badge, color: "#5b6472", background: "#eef1f3" }}>Sin categoría</span>
                  )}
                </td>
                <td style={styles.td}>{p.contacto || "—"}</td>
                <td style={styles.td}>
                  {(p.retenciones || []).length > 0 ? (
                    p.retenciones.map((r) => (
                      <span key={r.id} style={{ ...styles.badge, color: "#fff", background: "var(--tema-titulo, #0b3c60)", marginRight: "0.25rem" }}>
                        {r.nombre} {r.porcentaje}%
                      </span>
                    ))
                  ) : (
                    <span style={{ ...styles.badge, color: "#5b6472", background: "#eef1f3" }}>No</span>
                  )}
                </td>
                <td style={styles.td}>
                  {p.tiene_credito ? (
                    <span style={{ ...styles.badge, color: "#2f7a54", background: "#dcf0e6" }}>Sí</span>
                  ) : (
                    <span style={{ ...styles.badge, color: "#5b6472", background: "#eef1f3" }}>No</span>
                  )}
                </td>
                <td style={styles.td}>
                  {p.exento_iva ? (
                    <span style={{ ...styles.badge, color: "#9c7a1a", background: "#f3ecd0" }}>Exento</span>
                  ) : (
                    <span style={{ ...styles.badge, color: "#5b6472", background: "#eef1f3" }}>15%</span>
                  )}
                </td>
                <td style={{ ...styles.td, textAlign: "right" }}>
                  <button onClick={() => editar(p)} style={styles.botonFila}>
                    ✏️ Editar
                  </button>{" "}
                  <button onClick={() => eliminar(p.id)} style={styles.botonFilaPeligro}>
                    🗑️ Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        </>
      )}
    </div>
  );
}

const styles = {
  card: {
    border: "1px solid #e2e6ea",
    borderRadius: 14,
    padding: "1.1rem 1.2rem",
    background: "#fff",
    boxShadow: "0 1px 3px rgba(27,42,74,0.06)",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.6rem",
    marginBottom: "1rem",
  },
  cardIcono: {
    width: 34,
    height: 34,
    borderRadius: 9,
    background: "#e1e7f5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.1rem",
    flexShrink: 0,
  },
  form: { border: "1px solid #eef1f3", borderRadius: 10, padding: "1rem", marginBottom: "1rem", background: "#fafbfc" },
  grid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.6rem" },
  input: { padding: "0.45rem 0.6rem", border: "1px solid #d3d9df", borderRadius: 6, fontFamily: "inherit", fontSize: "0.88rem" },
  checkboxLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.4rem",
    fontSize: "0.85rem",
    marginBottom: "0.5rem",
  },
  botonAgregar: {
    background: "#3d5a99",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "0.5rem 1rem",
    fontSize: "0.85rem",
    fontWeight: 600,
    cursor: "pointer",
  },
  botonCancelar: {
    background: "#fff",
    color: "var(--tema-titulo, #0b3c60)",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    padding: "0.5rem 1rem",
    fontSize: "0.85rem",
    fontWeight: 600,
    cursor: "pointer",
  },
  tablaWrap: { border: "1px solid #eef1f3", borderRadius: 10 },
  tabla: { width: "100%", borderCollapse: "collapse", fontSize: "0.88rem" },
  th: {
    padding: "0.55rem 0.5rem",
    background: "#eef1f3",
    border: "1px solid #d3d9df",
    fontSize: "0.76rem",
    color: "var(--tema-titulo, #0b3c60)",
  },
  td: { padding: "0.5rem 0.6rem", textAlign: "left" },
  badge: {
    display: "inline-block",
    padding: "0.15rem 0.55rem",
    borderRadius: 999,
    fontSize: "0.75rem",
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  botonFila: {
    border: "1px solid #d3d9df",
    background: "#fff",
    borderRadius: 6,
    padding: "0.3rem 0.6rem",
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "var(--tema-titulo, #0b3c60)",
    cursor: "pointer",
  },
  botonFilaPeligro: {
    border: "1px solid #f7ded9",
    background: "#fff",
    borderRadius: 6,
    padding: "0.3rem 0.6rem",
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#a3402f",
    cursor: "pointer",
  },
};

export default GestionarProveedores;
